import React from 'react'
import PropTypes from 'prop-types'
import { Columns, Column } from 'react-flex-columns'
import Avatar from './Avatar'
import Icon from 'shared/ui/Icon'
import './Tweet.scss'

export function Tweet({ children, handle, tweetId }) {
  function click() {
    window.location.href = `https://twitter.com/${handle}/status/${tweetId}`
  }

  return (
    <div className="tweet" role="button" onClick={click} onKeyDown={click} tabIndex="-1">
      <Columns gutterSize={0.5} middle>
        <Column>
          <Avatar
            size={1.8}
            src={`/images/avatars/twitter/${handle}.jpg`}
            alt={`Twitter Avatar for ${handle}`}
          />
        </Column>
        <Column flex>
          <div className="tweet-handle">@{handle}</div>
        </Column>
        <Column size={2}>
          <Icon color="brightBlue" name="twitter" />
        </Column>
      </Columns>
      <q>{children}</q>
    </div>
  )
}

Tweet.propTypes = {
  children: PropTypes.node.isRequired,
  handle: PropTypes.string.isRequired,
  tweetId: PropTypes.string.isRequired,
}

export function TweetContent({ children }) {
  if (typeof children !== 'string') return children

  // In the content, find references to twitter handles or hash tags
  const parsed = children.split(' ').map((word, key) => {
    if (!['#', '@'].includes(word.substring(0, 1))) return word
    const props = {
      key,
      tabIndex: -1,
      onClick: e => {
        e.stopPropagation()
      },
    }
    return word.substring(0, 1) === '#' ? (
      <a {...props} href={`https://twitter.com/hashtag/${word.substring(1)}`} children={word} />
    ) : (
      <a {...props} href={`https://twitter.com/${word.substring(1)}`} children={word} />
    )
  })

  // little trick to put the spaces back in
  return parsed
    .reduce((all, item) => {
      return all.concat([' ', item])
    }, [])
    .slice(1)
}

TweetContent.propTypes = {
  children: PropTypes.node.isRequired,
}
